"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useProduct2 = require("@/hooks/use-product");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
// 权限判断函数
var _default2 = exports.default = {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 系統表单列表
    systemFormList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formValidate: this.value,
      // 表单数据
      timeVal: [],
      week: [{
        id: 1,
        name: '周一'
      }, {
        id: 2,
        name: '周二'
      }, {
        id: 3,
        name: '周三'
      }, {
        id: 4,
        name: '周四'
      }, {
        id: 5,
        name: '周五'
      }, {
        id: 6,
        name: '周六'
      }, {
        id: 7,
        name: '周日'
      }],
      // 表单验证规则
      rules: {
        bookingPeriod: [{
          required: true,
          message: '请选择可预约时段',
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    formValidate: {
      handler: function handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true
    },
    timeVal: function timeVal(val) {
      this.formValidate.supplementReservation.reservationDateStartDate = val[0];
      this.formValidate.supplementReservation.reservationDateEndDate = val[1];
    }
  },
  mounted: function mounted() {
    if (this.formValidate.supplementReservation.reservationDateType == 2) {
      this.timeVal = [this.formValidate.supplementReservation.reservationDateStartDate, this.formValidate.supplementReservation.reservationDateEndDate];
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    },
    // 刷新表单
    changeSystemFormList: function changeSystemFormList() {
      this.$emit('handleSystemFormList');
    },
    toggleWeekday: function toggleWeekday(id) {
      if (this.isDisabled) return;
      var index = this.formValidate.supplementReservation.reservationDateWeekRangeList.indexOf(id);
      if (index > -1) {
        this.formValidate.supplementReservation.reservationDateWeekRangeList.splice(index, 1);
      } else {
        this.formValidate.supplementReservation.reservationDateWeekRangeList.push(id);
      }
    },
    getFormList: function getFormList() {
      this.$emit('getFormList');
    },
    getFormInfo: function getFormInfo() {
      this.$emit('getFormInfo');
    }
  }
};